import React from "react";

import { Carousel } from "react-responsive-carousel";

import "./externalStyles.scss";

const ImageCarousel = ({
  children,
  selectedItem,
  onChange,
  thumbWidth,
  renderCustomThumbs,
  swipeable = true,
}) => (
  <Carousel
    {...Carousel.defaultProps}
    selectedItem={selectedItem}
    onChange={onChange}
    thumbWidth={thumbWidth}
    swipeable={swipeable}
    {...(renderCustomThumbs ? { renderThumbs: renderCustomThumbs } : {})}
  >
    {children}
  </Carousel>
);

export default ImageCarousel;
